import angular from 'angular';
import databrowserComponent from './dataBrowser.component';

let databrowserModule = angular.module('databrowser', []).directive('databrowser', databrowserComponent);

export default databrowserModule;



// WEBPACK FOOTER //
// ./app/components/dataBrowser/dataBrowser.js